export const timeDays = [
  {
    label: {
      ne: 'विहानी',
      en: 'AM',
    },
    value: 'AM',
  },
  {
    label: {
      ne: 'बेलुका',
      en: 'PM',
    },
    value: 'PM',
  },
] as const
